import { enumValue, gapIsAddressed, gapIsFailed } from '~/util';

export function statusStyle(status: number) {
    switch (status) {
        case enumValue(['gap', 'status', 'Pending']):
            return 'info';
        case enumValue(['gap', 'status', 'Fail']):
        case enumValue(['gap', 'status', 'Insufficient']):
            return 'warning';
        case enumValue(['gap', 'status', 'Under Review']):
            return 'secondary';
        case enumValue(['gap', 'status', 'Addressed']):
        case enumValue(['gap', 'status', 'Confirmed']):
        case enumValue(['gap', 'status', 'Disagree/Resolved/Closed']):
        case enumValue(['gap', 'status', 'Non-DataRap Covered']):
            return 'success';
        default:
            return '';
    }
}

export function cardStatusStyle(gap: GapType) {
    switch (gap.status) {
        case enumValue(['gap', 'status', 'Pending']):
        case enumValue(['gap', 'status', 'New']):
        case enumValue(['gap', 'status', '']):
            return 'border-info';
        case enumValue(['gap', 'status', 'Not Compliant']):
            return 'border-dark';
        case enumValue(['gap', 'status', 'Under Review']):
            return 'border-secondary';
        case enumValue(['gap', 'status', 'Confirmed']):
            return 'border-success';
        default:
            if (gapIsAddressed(gap)) {
                return 'border-success';
            }
            if (gapIsFailed(gap)) {
                return 'border-warning';
            }
            return '';
    }
}

export function cardDescriptionClass(gap: GapType) {
    switch (gap.metadata?.Color) {
        case 'PINK':
            return 'alert alert-danger';
        case 'RED':
            return 'alert alert-danger-red';
        case 'LightGoldenrodYellow':
            return 'alert alert-warning';
        case '#b7b7f1':
            return 'alert alert-info-purple';
        case 'WHITE':
            return '';
        default:
            return 'alert';
    }
}
